import { Layout } from 'antd';
import React from 'react';

import './index.less';

import SbBrowserUnsupportedModal from '../../components/SbBrowserUnsupportedModal';

const { Content } = Layout;

const SimpleBotEmployeeLayout: React.FC = (props) => {
  const { children } = props;

  return (
    <Layout className="sb-employee-layout">
      <Content className="sb-employee-layout__content">{children}</Content>
      <SbBrowserUnsupportedModal />
    </Layout>
  );
};

export default SimpleBotEmployeeLayout;
